import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Icon, { GLYPHS } from '../icon';

import { getDayOnConflictTooltip, getScheduleDayConflictTooltip } from './getScheduleConflictTooltip';

export const WorkDayConflictTooltip = ({ tooltipHeader, tooltipText }) => (
  <div className="c-info-tooltip-new__content u-p-- c-days-conflict-tooltip">
    <span className="u-type--bold">
      <Icon glyph={GLYPHS.warningTriangle} />
      &nbsp;{tooltipHeader}
    </span>
    <p className="u-mt--">{tooltipText}</p>
  </div>
);

WorkDayConflictTooltip.propTypes = {
  tooltipHeader: PropTypes.string.isRequired,
  tooltipText: PropTypes.string.isRequired,
};

const WorkDayConflictIconWithTooltip = ({ className, dayConflicts, type }) => {
  const tooltip = (type === 'dayOnOff')
    ? getDayOnConflictTooltip(dayConflicts)
    : getScheduleDayConflictTooltip(dayConflicts);

  return (
    <div className={classnames('c-info-tooltip-new-handler', className)}>
      <Icon glyph={GLYPHS.warningTriangle} data-automation-id="day-conflict-icon" />
      <WorkDayConflictTooltip
        tooltipHeader={tooltip.title}
        tooltipText={tooltip.text}
      />
    </div>
  );
};

WorkDayConflictIconWithTooltip.propTypes = {
  className: PropTypes.string,
  dayConflicts: PropTypes.arrayOf(PropTypes.object).isRequired,
  type: PropTypes.oneOf(['dayOnOff', 'schedule']),
};

WorkDayConflictIconWithTooltip.defaultProps = {
  type: 'schedule',
  className: '',
};

export default WorkDayConflictIconWithTooltip;
